import { useState, useCallback } from 'react';

/**
 * State helper for a "tabbed" result-details navigation where at most one detail
 * category is open at a time (exclusive). Mirrors the Substance result behaviour
 * so it can be shared across result types (Document, Reaction, Target).
 *
 * @param {string|null} initialId - category id open on first render (null = none).
 */
export default function useExclusiveDetails(initialId = null) {
  const [activeId, setActiveId] = useState(initialId);

  // Clicking the active category closes it; clicking another switches to it.
  const toggle = useCallback((id) => {
    setActiveId((prev) => (prev === id ? null : id));
  }, []);

  const open = useCallback((id) => setActiveId(id), []);
  const close = useCallback(() => setActiveId(null), []);

  return { activeId, toggle, open, close };
}
